import React from "react";

// A simple utility to format the currency
const formatCurrency = (amount) => {
  return (
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "ETB",
      currencyDisplay: "code",
    })
      .format(amount)
      .replace("ETB", "")
      .trim() + " ETB"
  );
};

const RecentActivityList = ({
  title = "Recent Activity",
  transactions = [],
}) => {
  if (transactions.length === 0) {
    return null; // Don't render anything if there are no transactions
  }

  return (
    <div className="mt-8 pt-6 border-t border-slate-200">
      <h3 className="text-lg font-semibold text-slate-800 mb-4">{title}</h3>
      <div className="flow-root">
        <ul role="list" className="-mb-4">
          {transactions.map((transaction, index) => (
            <li
              key={transaction.id}
              className={`py-4 ${
                index !== transactions.length - 1
                  ? "border-b border-slate-100"
                  : ""
              }`}
            >
              <div className="flex items-center space-x-4">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-slate-900 truncate">
                    {transaction.description}
                  </p>
                  <p className="text-sm text-slate-500 truncate">
                    {transaction.date}
                  </p>
                </div>
                <div className="inline-flex items-center text-base font-semibold text-slate-900">
                  +{formatCurrency(transaction.amount)}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RecentActivityList;
